export default __webpack_public_path__ + "static/media/chime5.5a8dc645.mp3";